import { useTheme } from 'styled-components';
import { ThemeTypes } from '../theme/theme';

const useThemeContext = (): ThemeTypes => {
  const tema = useTheme() as ThemeTypes;

  return tema;
};

export default useThemeContext;
